import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'
import FilesAndDirectoriesService, { Type } from '../../../services/FilesAndDirectoriesService'

type MoveItemPayload = {
  organization: string
  path: string
  newPath: string
  type: Type
}

export const useMoveItem = (directoryPath?: string) => {
  const { org, project } = useParams()
  const queryClient = useQueryClient()

  return useMutation<any, Error, MoveItemPayload>({
    mutationKey: ['move-project-item'],
    mutationFn: ({ organization, path, newPath, type }) =>
      FilesAndDirectoriesService.move(organization, path, newPath, type),
    onSuccess: () => {
      directoryPath
        ? queryClient.invalidateQueries({ queryKey: ['directory-content', org, project, directoryPath] })
        : queryClient.invalidateQueries({ queryKey: ['project-content', org, project] })
    },
  })
}
